import * as $ from 'jquery';
import * as _ from 'underscore';
import {UserWhitespacable} from "babel-types";
import UserInterface from './UserInterface';
import * as parser from 'ua-parser-js';
import {PanotestComponent} from './panotest.component';
import {PanotestService} from './panotest.service';

//import {clearInterval} from 'timers';




export default class MyClass {
  panels: object;
  helptext: string = '';
  currentInteraction: Action;
  ui: UserInterface;
  self = this;
  //==============================================
  //CHANGE EACH MODULE IN THE CONSTRUCTOR
  module: number = 1;
  //==============================================

  topic: number = 0;
  topics: Topic[];
  topicReady = false;
  maxTopic: number = 0;
  isModuleCompleted: boolean = false;
  lmsMode = true;
  //LMS: Lms;
  lmsLog: string = 'LMS:: ';
  topicData: string;
  showMsgBox = false;
  showMsgText: string = '';
  currentSceneId: number;
  currentModuleTopics: any[];
  ua: any;

  showSplash = true;
  showHelpPopup = false;
  showExitPopup = false;
  showMapPopup = false;
  splashStep = 3;
  viewedHelp = false;
  viewedMap = false;
  idleTimer: any;
  showHoverText: boolean = true;
  version='1.75';
  dataDump = false;
  dataDumpContents = '';
  idleActivity: Action;
  clickAction: Object;
  pano: PanotestComponent;
  panoservice: PanotestService;



  disableAutoVideo: boolean = false;
  clickDismissHerotext: boolean = true;

  constructor(panoservice: PanotestService, p: PanotestComponent) {
    //hookups
    this.panoservice = panoservice
    this.pano = panoservice.scope;
    console.log('MyClass '+ this.module + 'version: '+ this.version);
    this.module = this.module || 1;
    this.ua = parser();
    this.ua.platform = (this.ua.device && this.ua.device.model)? this.ua.device.model : 'Unknown';
    this.init();

  }




  helpText(event: any) {
    console.log('update text', event)
    if(event) {
      this.helptext = event.target.alt;
      $('#helpText').css({left: event.target.offsetLeft - 60});
    }
  }

  showMsg(txt: string) {
    this.showMsgText = txt;
    this.showMsgBox = true;
  }

  unlockTopics(){
    console.log('******************** UNLOCK '+this.module)
    const currentTopics = _.where(this.topics,{ module: this.module});
    console.log(currentTopics);
    if (currentTopics) {
      _.each(currentTopics, function (t: Topic) {
        t.active = true;
      });
    } else {
      //No current topics
      console.log('Cant unlock topics...module=' + this.module);
    }

  }




  //Idle Highlight
  //Bounce the current widget as a subtle prompt
  startIdleTimer() {
    this.idleTimer = window.setInterval(this.idleHighlight, 2000, this)
  }
  idleHighlight(arg) {

      if (arg.currentInteraction && !arg.currentInteraction.completed) {

        arg.panoservice.ui.highlightCurrentWidget()

      } else {

        arg.killIdleTimer();
      }

  }
  killIdleTimer() {
    clearInterval(this.idleTimer);
  }

  //Sets the interaction passed(arg) as current, so we can skip the order when we need to. Do not process any click events here.
  setCurrentInteraction(arg: any) {
    console.log('');
    console.log('SET CURRENT INTERACTION VIA CLICK OR SCRIPT', arg);

    let i

    if (arg instanceof Object) {
      i = arg;

    } else {
      //number
      i = this.getActionById(arg);
    }

    if(i) {

      if(!i.active) i.active = true;              // activate if isn't

      if(i.devNote) this.panoservice.scope.debugNote = i.devNote;

      //Need to check we haven't moved to a different scene and not finished a previous scene
      console.log('Same Scene? current: '+ this.currentSceneId + ' action: ' + i.sceneId)
      if( i.sceneId !== this.currentSceneId) {
        console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&& WRONG SCENE');
        return
      }



      if (i === this.currentInteraction) {
        console.log('Same interaction. Bugging out!!!!!!!!!!!!!!!!!!!!!!!');
        //return
      }   // Exit if same interaction



      if (!i.completed && i.mission) {
        console.log('SETCURRENT: setUserMission')
        this.panoservice.ui.setUserMission(i);
        if (i.button) {
          //we have a button to show on the info text panel

          this.panoservice.ui.assignedButtonLabel = i.buttonLabel || 'OK';
        } else {

          this.panoservice.ui.assignedButtonLabel = '';
        }

        if(i.audioPrompt) {

          if(!i.audioSet ) this.panoservice.ui.playAudioPrompt(i.audioPrompt);
          i.audioSet = true;
        }



      }else{

      }

      this.killIdleTimer();
      //We might need to enable the next interaction's spot if its locked
      this.currentInteraction = i;
      console.log(' ');
      console.log(' ');
      console.log(' ');
      //we can jump around other interactions.
      console.log('SET Current Interaction::' + this.currentInteraction.desc);
      console.log(' ');

      if(!i.showMenu) {
        this.panoservice.scenes.enableWidget(this.currentInteraction.infoSpotId);

        if (this.currentInteraction.activeIncludes) {
          for (let ai = 0; ai < this.currentInteraction.activeIncludes.length; ai++) {
            console.log('Also enabling ' + this.currentInteraction.activeIncludes[ai]);
            this.panoservice.scenes.enableWidget(this.currentInteraction.activeIncludes[ai]);
          }
        }

        if (this.currentInteraction.activateGroup) {
          let g = _.where(this.getCurrentActvities(), {group: this.currentInteraction.activateGroup});
          console.log('GROUP ON ',g);
          if(g) _.each(g, (a) => { this.panoservice.scenes.enableWidget(a.infoSpotId);});

        }


        //if(this.currentInteraction.hasOwnProperty('infoSpotId')) this.startIdleTimer();


      }else{
        //clean up just incase
        //this.panoservice.ui.hideArrows();
      }


      if(i.exeOnInit){
        //Process the onclick for this action.
        if(this.disableAutoVideo && i.onclick && i.onclick.type === 'play_video') {
          //don't bother showing the intro videos. But we may need to unlock any action groups so we'd need to move to the next action to trigger this.
          i.completeOnInit = true;
        }else{
          this.processClick(i);
        }

      }

      //and finally do we just treat this as completed when initialised.
      if(i.completeOnInit) {
        //dodgy..not used as yet
        this.interactionCompleted(i);
      }

      if(i.showMenu) {
        //we have completed the topic so this interaction is to be completed.
        i.completed = true;             //mark it off..cant use completeOnInit as it clears things
        this.checkTopicCompletion();    //lms stuff etc
        window.setTimeout(function(scope) {
          console.log('SHow MAP for topic completion');
          scope.showMap();

        },2000, this );
      }




    } else {

      console.log('ERROR: NO interaction found !!!!!!!!!!!!!!!')

    }


  }
  setNextInteraction(): boolean {

    //if (!this.topics[this.topic].completed) {}

      //find next interaction that isnt completed and clear out the current
      //this.currentInteraction = null;

      console.log(this.topics[this.topic].interactions)
      let next = _.findWhere(this.topics[this.topic].interactions, {completed: false, sceneId: this.currentSceneId});
      console.log('Get next interaction for this scene ' + this.currentSceneId);
      console.log(next);

      if (next) {
        console.log('setNextInteraction::FOUND ', next)
        this.setCurrentInteraction(next);
        return true
      } else {
        console.log('All interactions are completed or void');
        this.setCurrentInteraction(this.idleActivity);
        return false
      }

  }
  interactionCompleted(i: Action = this.currentInteraction) {
    console.log(' ');
    console.log(' =======================================');
    console.log(' GAME: INTERACTION COMPLETED', i.desc);
    i.completed = true;
    //Hide messages, timers and stop audio
    this.killIdleTimer();
    this.panoservice.ui.hideAllQuiz();

    this.panoservice.ui.stopAllAudio();
    if (i.infoSpotId) this.panoservice.ui.completedWidget(i);
    //this.panoservice.ui.setUserMission(''); //hopefully kill any timers
    //Part of a group and not completed?
    if (i.group) {
      if(!this.checkGroupCompletion()){
        this.setNextInteraction();
      }

    }else{
      if (!this.checkTopicCompletion()) this.setNextInteraction();
    }



  }
  resetInteractions(){
    _.each(this.getCurrentTopic().interactions, function(i: any){
      i.completed = false;
    });

  }

  //Completions
  checkGroupCompletion(obj: Action = this.currentInteraction){
    if(obj.group) {

      let g = _.where(this.getCurrentActvities(), {group: this.currentInteraction.group});  //get list of group members
      if (_.findWhere(g, {completed: false})) {
        //still more in group
        console.log('Group not complete');
        return false
      }else{
        //group is all done...move onto next interaction
        console.log('Group complete');
        //complete the group parent
        const p: Action = _.findWhere(this.getCurrentActvities(), {activateGroup: this.currentInteraction.group});
        p.completed = true;
        this.interactionCompleted(p);
        return true;
      }

    }
  }
  checkTopicCompletion(): boolean {
    console.log('Checking topic completion..');
    const topic = this.getCurrentTopic();
    console.log(topic)
    if (_.every(topic.interactions, function (t: Action) {
        return t.completed;
      })) {

        if (topic.completed == false) {
          this.completeTopic(this.topic);
        }

        return true;

    }else{
        console.log('Topic NOt completed.')
        return false;
    }

  }
  completeTopic(t:number){
    const topic = this.topics[t];
    topic.completed = true;
    console.log(' ');
    console.log('Topic ' + this.getCurrentTopic().title + ' completed');

    /*if (this.LMS.lmsConnected) {
      this.lmsLogger('LMS CONNECTED: SAVING');
      this.LMS.setData(_.pluck(this.topics, 'completed'));
      this.LMS.save();
    } else {
      this.lmsLogger('completeTopic :: LMS NOT CONNECTED');
    }*/

    //unlock next topic
    let next = this.topics[t + 1];
    console.log(next)
    if (next) {
      if(next.module == topic.module){
        next.active = true;
      }else{
        //different module so check this module is complete...just incase
        if(this.checkModuleCompletion()){ this.moduleCompleted() }
      }
    } else {
      //End of topics...
      if(this.checkModuleCompletion()){ this.moduleCompleted() }
    }

}
  moduleCompleted(){
    console.log('!!!!MODULE COMPLETED');
    //this.LMS.lessonCompleted();
    //this.LMS.save();
  }
  checkModuleCompletion(){
    const currentTopics = _.where(this.topics,{ module: this.module});
    if (currentTopics) {
      if (_.every(currentTopics, function (t: Topic) {
        return t.completed;
      })) {
        return true;
      } else {
        return false;
      }
    } else {
      //No current topics
      console.log('Cant check module completion: no topics found...module='+this.module)
    }
  }

  //Getters
  getCurrentModule(){
    this.currentModuleTopics = _.where(this.topics,{ module: this.module});
    console.log('....');
    console.log('....');
    console.log('MODULE: '+this.module);
    console.log(this.currentModuleTopics);

    return this.currentModuleTopics;
  }
  getCurrentTopic(): Topic {
    return this.getTopic(this.topic);
  }
  getTopic(topicIdx: number): Topic {
    return this.topics[topicIdx];
  }
  getActivity(topicIdx: number, activityIdx: number) {
    return this.topics[topicIdx].interactions[activityIdx];
  }
  getInteraction(topic: Topic = this.getCurrentTopic(), interaction: number): Action {
    return topic.interactions[0] || null;
  }
  getCurrentActvities() {
    return this.getCurrentTopic().interactions;
  }
  getPanoActivities(){
    return _.pluck(this.getCurrentActvities(), 'infoSpotId');
  }
  getPanoActivitiesByScene(s: number){
    const list = _.where(this.getCurrentActvities(), {sceneId: s});
    return _.filter(list, function(a: Action){
      return a.hasOwnProperty('infoSpotId')
    });
    //return  _.pluck(_.where(this.getCurrentActvities(), {sceneId: s}), 'infoSpotId');
  }
  getScenesForTopic(t: number){
    return this.panoservice.scope.scene;
  }
  checkMouseMoves(x: number, initialX: number, sceneId) {
    //Only specific for the first task, but maybe need to handle other look around actions later


  }
  checkArrowMouseMove(x: number, initialX: number) {
      //console.log('ARROW ', x, initialX);
      const del = Math.abs(Math.abs(x) - Math.abs(initialX));
      if (del > 0.45) {
        //moved the mouse a little in either direction(will do for now)
        //this.panoservice.ui.hideArrows();
      }
  }

  gotoScene(sceneIdx: number){
    console.log(this.panoservice.panoramaArray);
    let pano = _.findWhere(this.panoservice.panoramaArray, {sceneId: sceneIdx});

    if(pano) {

      if(!this.topic) this.initTopic(1,false);  //if we haven't loaded a topic better do so.

      //some things we want to get rid of BEFORE the next pano loads
      this.panoservice.ui.killHero();      //kill panels etc
      this.panoservice.game.showSplash = false;
      this.showMsgBox = false;    //get rid of if we are moving.
      this.panoservice.ui.showVideoPlayer = false;
      this.panoservice.ui.showAudioPlayer = false;
      this.panoservice.ui.showImageViewer = false;
      this.showMapPopup = false;


      this.panoservice.scope.gotoPano(pano);
    }
    //this.panoservice.scope.gotoPano(_.findWhere(this.panoservice.sceneData1, {id: sceneIdx}));
  }

  //When we enter a SCENE, NOT A PANO
  enterScene(scene: Scene) {
    if(!scene) {
      console.log( 'GAME.enterScene: ERROR NO SCENE');
    }

    console.log('>>>>>>>>>>>>> GAME: ENTER SCENE T:' + this.topic + ' SCENE:' + scene.id);
    //Handle the move to actions..must find a better way

    let e = document.getElementById('sceneTitle');
    if(e) e.parentNode.removeChild(e);
    this.panoservice.ui.showHtmlPopup = false;


    this.currentSceneId = scene.id;

    //bit of delay to allow the scene to fade in first
    window.setTimeout(function () {
      $('#sceneInfo').fadeIn();
    }, 1000);

    if (this.currentInteraction && this.currentInteraction.targetLoc) {
      //The current interaction is to move somewhere
      if (scene.id == this.currentInteraction.targetLoc) {
        //we have arrived.
        this.interactionCompleted();
      } else {
        this.setNextInteraction();
      }
    } else {
      this.setNextInteraction();
    }




  }


  initModule(m: number){
    //module change
    this.module = m;


  }
  closeAllPanels() {
    this.panoservice.ui.audioPrompt = '';
    this.panoservice.ui.sysAudioPlayerUrl = '';
    this.panoservice.ui.stopAllAudio();
    this.panoservice.ui.htmlPopupId = 0;
    this.panoservice.ui.showAudioPlayer = false;
    this.panoservice.ui.showVideoPlayer = false;
    this.panoservice.ui.showImageViewer = false;
    this.panoservice.ui.showHtmlPopup   = false;
    this.panoservice.ui.immiImgIdx = 0; //reset the image spinner


  }
  processClick(obj: Action){

    //image or video via detected url
    this.panoservice.ui.stopAllAudio();


      console.log('Process OnClick Data');
      if(obj.onclick.type=='play_audio') {
        this.closeAllPanels();
        this.panoservice.ui.videoPlayerURL = obj.onclick.url
        console.log('PLAY AUDIO ', obj.onclick);
        this.panoservice.ui.audioImg = obj.onclick.img;
        this.panoservice.ui.audioTitle = obj.onclick.title;
        this.panoservice.ui.audioDesc = obj.onclick.desc;
        this.panoservice.ui.audioHtml = obj.onclick.html || '';


        this.panoservice.ui.showAudioPlayer = true;
        window.setTimeout(this.panoservice.ui.setVideo, 500);

      }

    if(obj.onclick.type=='play_sysaudio') {
      this.closeAllPanels();
      this.panoservice.ui.playAudioViaButton(obj.onclick.url);
      console.log('PLAY AUDIO ', obj.onclick);
      this.panoservice.ui.audioImg = obj.onclick.img;
      this.panoservice.ui.audioTitle = obj.onclick.title;
      this.panoservice.ui.audioDesc = obj.onclick.desc;
      this.panoservice.ui.audioHtml = obj.onclick.html || '';

      this.panoservice.ui.showAudioPlayer = true;
      window.setTimeout(this.panoservice.ui.setVideo, 500);

    }

      if(obj.onclick.type=='play_video') {

        console.log('PLAY VIDEO ', obj.onclick.url);
        this.panoservice.ui.videoPlayerURL = obj.onclick.url
        this.closeAllPanels();
        this.panoservice.ui.showVideoPlayer = true;
        window.setTimeout(() => { this.panoservice.ui.setVideo()}, 500);

      }
      if(obj.onclick.type=='play_image') {
        console.log('PLAY IMAGE ', obj.onclick.url);
        this.closeAllPanels();
        this.panoservice.ui.videoPlayerURL = obj.onclick.url
        if (this.panoservice.ui.videoPlayerURL.toLowerCase().indexOf('jpg') !== -1 || this.panoservice.ui.videoPlayerURL.toLowerCase().indexOf('png') !== -1) {
          this.panoservice.ui.showImageViewer = true;
        }
      }
      if(obj.onclick.type=='play_quiz') {
        console.log('PLAY QUIZ ', obj.onclick.url);
        this.closeAllPanels();
        this.panoservice.ui.showHtmlPopup = true;
        this.panoservice.ui.htmlPopupId = obj.onclick.quizId;
        if(obj.onclick.audioPrompt) {
          this.panoservice.ui.playAudioPrompt(obj.onclick.audioPrompt);
        }

      }
    if(obj.onclick.type=='show_info') {
      console.log('SHOW INFO ', obj.onclick.url);
      this.closeAllPanels();
      this.panoservice.ui.showHtmlPopup = true;
      this.panoservice.ui.htmlPopupId = obj.onclick.popupId;
      if(obj.onclick.audioPrompt) {
        this.panoservice.ui.playAudioPrompt(obj.onclick.audioPrompt);
      }


    }

    if(obj.onclick.type=='heroText'){
      this.panoservice.ui.heroText = obj.onclick.text;
      this.panoservice.ui.heroTextStart();

    }

    if(obj.onclick.type === 'goto_topic') {
      obj.completed = true;

      this.initTopic(obj.onclick.topic);
    }
    if(obj.completeOnClick){
      console.log('completeOnClick complete');
      this.interactionCompleted();
    }



  }



  getActionById(id: number) {

    let inty = _.findWhere(this.getCurrentTopic().interactions, {id: id})

    console.log('Found actionByID ' + id + " - " + inty);
    return inty;


  }

  initCourse(startTopic: number = 0) {
    console.log(' ');
    console.log(' ** INIT COURSE ** ');
    console.log(' ');
    this.topicReady = false;
    this.panoservice.scope.initViewer(); //build viewer
    this.panoservice.initPano();        //build panos
    this.showStartScreen();
    this.getCurrentModule();
    let o =''
    if(this.dataDump){
      const dd = this.getCurrentModule();
      _.each(dd, function(t,idx){

        o += '<h2>' + t.title + '</h2><br>';
        _.each(t.interactions, function(i: any,idx){
          o += '<div style="border-radius: 6px;padding: 8px; border: 1px solid #333333;margin-bottom: 16px">'
          o += '<div class="ddmission" style="background-color: #333333;color: white; border-radius: 6px;padding: 16px; width: 50%">' + i.mission + '</div><br>';
          o += 'ID: '+ i.id + "<br>iCODE:<b>" + i.icode + '</b><br>';
          if (i.title) o += 'TITLE: <b>' +  i.title + '</b><br>';
          if (i.tipIcon) o += 'ICON: ' +  i.tipIcon + '<br>';
          if (i.showArrow) o += 'ARROW: ' +  i.showArrow + '<br>';
          if (i.url) o += 'URL: ' + i.url + '<br>';
          o += '</div>';

        }, this);

      }, this);
    }


    this.dataDumpContents = o;


  }
  exitCourse(){
    console.log('EXIT COURSE');
    console.log('SAVING TO LMS');
    //this.LMS.save();
    window.setTimeout(function(){
      console.log('CLOSING WINDOW');
      window.close();
    }, 1000)

  }



  showHelp() {
    this.viewedHelp = true;
    this.showHelpPopup = !this.showHelpPopup;
  }
  showMap() {
    this.viewedMap = true;
    this.showMapPopup = !this.showMapPopup;
    this.panoservice.ui.showMap();
  }
  showExit(){
    this.showExitPopup = !this.showExitPopup;
  }
  showStartScreen() {

    console.log('START SCREEN');
    this.panoservice.ui.userMission = '';
    this.panoservice.ui.showBlocker();
    this.topic = 0;
    this.panoservice.scope.initTopic(0); //Menu
    this.panoservice.scope.viewer.setPanorama(this.panoservice.PANO.MENU);
    this.topicReady = true;
    this.panoservice.ui.hideBlocker();

  }

  initTopic(t: number, splash:boolean=false, sceneId: number = 0) {

    console.log('GAME: InitTopic ' + t +' Splash: '+ splash);

    if(splash) {
      t = t + this.maxTopic;
    }

    this.showMapPopup = false;
    this.showHelpPopup = false;
    this.showSplash = false;
    this.panoservice.ui.userMission = '';
    this.panoservice.ui.showUserInfo = false;
    this.panoservice.ui.showBlocker();
    this.topic = t;

    this.resetInteractions();
    this.panoservice.scope.initTopic(t, sceneId);
    this.setCurrentInteraction(0);

    this.topicReady = true;

  }

  findLatestTopic(){
    //when resuming we need to see where the user is upto.
    console.log('Checking topic max..');
    const topics = this.getCurrentModule();
    let offset = Number(topics[0].id);    //Damn this works for grocery of course but we need to offset.
    let h = 0;
    _.each(topics, function (t: Topic) {
      if(t.completed) h++
    });
    this.isModuleCompleted = this.checkModuleCompletion();
    this.maxTopic = (this.isModuleCompleted)? topics.length-1 : h;

    let next = topics[h];
    console.log(next)

    if (next) {
      if (next.module == topics[h].module) {
        this.topics[offset + h].active = true;
        console.log('Activating NEXT topic');
        console.log(next);
      }
    }
    console.log('MAX TOPIC = ' + h);
    console.log('Activated ', next);

  }


  getActivityByInfoSpot(topicIdx: number, activityId: string) {
    console.log('activityId:' + activityId);
    return _.findWhere(this.topics[topicIdx].interactions, {infoSpotId: activityId});
  }

  lmsLogger(s:string){

    this.lmsLog += s+ '<br>';

  }

  initLMS(): boolean {
    if (this.lmsMode) {
      console.log('>>>>> INIT LMS <<<<<<');
      //this.LMS = new Lms();
      //this.LMS.init(this);
      /*if (this.LMS.lmsConnected) {
        this.lmsLogger('LMS CONNECTED');
        this.LMS.getStatus();
        if (this.LMS.completed) {
          //Let the user know have alrady completed this

          let s: string = this.LMS.getData();

          if (s) {
            this.topicData = s;

            _.each(this.topicData.split(','), function (c, idx) {
              if (this.topics[idx]) {
                this.topics[idx].completed = (c == 'true') ? true : false;
                this.topics[idx].active = (c == 'true') ? true : false;
              }
            }, this);


          }

          return true;
        } else {
          console.log('Course NOT Completed');
          let s: string = this.LMS.getData();

          if (s) {
            this.topicData = s;

            _.each(this.topicData.split(','), function (c, idx) {
              this.topics[idx].completed = (c == 'true') ? true : false;
              this.topics[idx].active = (c == 'true') ? true : false;

            }, this);


          }

          return true
        }
      } else {
        console.log('**********ERROR: LMS not connected');
        this.lmsLogger('LMS NOT CONNECTED!!!!!')
        return false
      }*/
    } else {
      this.lmsLogger('LMS NOT IN LMSMODE');
      return true
    }
  }

  setupVideo(idx) {

    return function () {
      this.setCurrentInteraction(idx);
      //UI.videoPlayerURL = 'assets/video/Michael_Cameron_Group_Orientation_Video.mp4';
      this.panoservice.ui.showVideoPlayer = true;
      window.setTimeout(this.panoservice.ui.setVideo, 500);
    }
  }

  //Kill this..messy

  makeWidget(index: number, id: string, interactionId: number, options: any) {

    const interaction = this.getCurrentTopic().interactions[interactionId];

    let tmp = {
      img: options.icon || this.panoservice.ui.icons.read,
      type: 'spot',
      index: index,
      text: options.text || interaction.desc || '',
      link: {
        coords: options.coords || {x: 2803.24, y: 510.66999999999996, z: 2081.88},
        size: options.size || 350,
        img: options.icon || this.panoservice.ui.icons.read,
        id: id || options.id || interaction.infoSpotId,
        text: options.text || interaction.desc || '',
        action: (function () {
          let f = function () {
            this.setCurrentInteraction(interaction.id || 0);
            if (options.videoUrl) {
              //UI.videoPlayerURL = options.videoUrl;
              this.panoservice.ui.showVideoPlayer = true;
              window.setTimeout(this.panoservice.ui.setVideo, 500);
            }

          }
          return f;
        })()
      }
    }

    return tmp;

  }

  playAudio(s: string){
    console.log('play audio!!! ', s);
    this.interactionCompleted(this.currentInteraction);
  }

  listenToIntroductions(scope){
    console.log('Play audio of starting a conversation');
    this.interactionCompleted(this.currentInteraction);
  }

  init() {

    this.idleActivity = {
      id: 99, desc: 'idle: nothing to do', icode: 'IDLE.0', active: true,
      mission: '<h4>This is nice.</h4><p>Not much to do here. Lets head back.</p>',
      missionTimer: 500, tipIcon: 'goto',
      label: 'Go back',
      coords: {x: 3140, y: -280, z: 2540},
      infoSpotId: 'IdleLink'
    }

    this.topics = [
      {
        title: 'MENU', id: 0, completed: false, active: true, interactions: []
      },
      {
        title: 'ACU Virtual Tour', id: 1, completed: false, active: true, module: 1, interactions: [


          //Flinders Street
          { id: 0,  desc:'Hero Text', sceneId: 6, completed: false, active: true, exeOnInit: true, onclick: { type: 'heroText', text: 'Flinders Street Station'} },
          {
            id: 6.1, desc: 'Flinders opener', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 1,
            tipIcon: 'video', exeOnInit: true,
            onclick: {type: 'play_video', url:'./assets/video/flinders.mp4'},
            coords: {x: 3183.24, y: -1189.33, z: 1801.88},
            infoSpotId: 'courtOpener', label: 'Introduction'
          },
          {
            id: 6.2, desc: 'Read Flinders Street History', icode: 'A1.0', completed: false, active: false,
            sceneId: 6, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readFlindersHistory',
            onclick: {
              type: 'show_info',
              popupId: 5,
              audioPrompt: './assets/audio/0020-acu-audio-20.mp3'
            },
            activateGroup: 'flinders1',
            coords: {x: 1023.2399999999998,y: 230.66999999999996,z: 4401.88},
            mission: '<h2>Welcome to Flinders Street</h2>' +
              '<p>Have a look around by moving to the left and right. Then, select the different icons to learn more.</p><br><p>When you are done, we can head towards Centre Place, which you will find on your right.</p>',
            missionIcon: 'map',
            audioPrompt: './assets/audio/rec1/welcometoflinders.mp3',

            label: 'History of Flinders Street Station'
          },
          {
            id: 6.3, desc: 'Read Young and Jackson', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readPub', onclick: {
              type: 'show_info',
              popupId: 6,
              audioPrompt: './assets/audio/0025-acu-audio-25.mp3'
            }, group: 'flinders1',
            coords: {x: 2383.24, y: 90.66999999999996, z: -4498.12}, mission: '', label: 'Young and Jackson Pub'
          },
          {
            id: 6.4, desc: 'Read Yarra', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readYarra', onclick: {
              type: 'show_info',
              popupId: 7,
              audioPrompt: './assets/audio/0026-acu-audio-26.mp3'
            }, group: 'flinders1',
            coords: {x: -3536.76, y: 470.66999999999996, z: 2761.88}, mission: '', label: 'The Yarra River'
          },
          {
            id: 6.5, desc: 'Read Aboriginal', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readPeople', onclick: {
              type: 'show_info',
              popupId: 8,
              audioPrompt: './assets/audio/0027-acu-audio-27.mp3'
            }, group: 'flinders1',
            coords: {x: -3416.76, y: 470.66999999999996, z: 1801.88}, mission: '', label: 'The Aboriginal People'
          },


          {
            id: 6.6, desc: 'Read St Kilda Beach', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readBeach',
            onclick: {
              type: 'show_info',
              popupId: 9,
              audioPrompt: './assets/audio/0029-acu-audio-29.mp3'
            }, group:'flinders1',
            coords: {x: -1236.7600000000002, y: 470.66999999999996, z: 3281.88}, mission: '', label: 'St Kilda Beach'
          },
          {
            id: 6.6, desc: 'Quiz What time is it', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 3, tipIcon: 'quiz',
            infoSpotId: 'quizTime', onclick: {type: 'show_info',
              popupId: 6.1,
              audioPrompt: 'assets/audio/0023-acu-audio-23.mp3'


            }, group: 'flinders1',
            coords: {x: 343.2399999999998, y: 1110.67, z: 4581.88}, mission: '', label: 'What time is it?'
          },
          {
            id: 6.7, desc: 'Read Federation Square', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readFed', onclick: {
              type: 'show_info',
              popupId: 10,
              audioPrompt: './assets/audio/0024-acu-audio-24.mp3'

            }, group: 'flinders1',
            coords: {x: -3756.76, y: 550.67, z: 441.8800000000001}, mission: '', label: 'Federation Square'
          },
          {
            id: 6.71, desc: 'Listen to an ACU student talk about Flinders Street Station', icode: 'A1.0', completed: false, active: false,
            sceneId: 6,
            iconOrder: 1,
            tipIcon: 'listen',
            group: 'flinders1', label: 'Listen to a student',
            infoSpotId: 'studentFlinders',
            onclick: {
              type: 'play_sysaudio',
              url: './assets/audio/0002-acu-audio-2.mp4',
              img: './assets/images/acu/zoe.jpg',
              title: 'Listen to student',
              desc: "Listen to an ACU student talk about Flinders Street Station."
            },
            coords: {x: 763.2399999999998, y: -349.33000000000004, z: 4661.88},
            devNote: 'Place holder audio'
          },
          {
            id: 6.8, desc: 'move: to Degraves', icode: 'A1.0', completed: false, active: false, sceneId: 6, iconOrder: 2,
            mission: "<h2>Let’s head over to Centre Place </h2><p>Order a coffee, learn some Australian slang and look at some street art.</p>", group:'flinders1',
            missionTimer: 500, tipIcon: 'goto',
            targetLoc: 7,
            panoName: 'Degraves',
            label: 'Visit Centre Place',
            coords: {x: 340, y: 20, z: -1580},
            infoSpotId: 'DegravesLink',
            completeOnMove: true

          },


          //------------------------------------------------------------ Centre Place



          { id: 7.0,  desc:'Hero Text', sceneId: 7, completed: false, active: true, exeOnInit: true, onclick: {
            type: 'heroText',
              text: 'Centre Place'} },
          {
            id: 7.1, desc: 'Degraves opener', icode: 'A1.0', completed: false, active: false, sceneId: 7, iconOrder: 1, tipIcon: 'video', exeOnInit: true,
            onclick: {
              type: 'play_video',
              url:'./assets/video/degraves.mp4'
            },
            coords: {x: 3183.24, y: -1189.33, z: 1801.88},
            infoSpotId: 'degravesOpener', label: 'View Intro video', devNote: ''
          },
          {
            id: 7.2, desc: 'Quiz Ordering Coffee', icode: 'A1.0', completed: false, active: false, sceneId: 7, iconOrder: 3,
            tipIcon: 'quiz',
            infoSpotId: 'quizCoffee', onclick: {
              type: 'show_info',
              popupId: 11,
              audioPrompt: './assets/audio/0033-acu-audio-33.mp3'
            }, group: 'degraves1', activateGroup: 'degraves1',
            coords: {x: -776.7600000000002, y: -929.33, z: -2918.12},
            mission: '<h2>Explore Centre Place</h2><p>This small laneway is for Melbourne coffee lovers. Explore the laneway then head off to Bourke Street Mall.</p>',
            missionIcon: 'map',
            label: 'Order a coffee',
            audioPrompt: './assets/audio/0032-acu-audio-32.mp3'
          },
          {
            id: 7.3, desc: 'Types of coffee', icode: 'A1.0', completed: false, active: false, sceneId: 7, iconOrder: 3,
            tipIcon: 'listen',
            infoSpotId: 'listenCoffee', onclick: {
              type: 'show_info',
              popupId: 12,
              audioPrompt: './assets/audio/0036-acu-audio-36.mp3'
              },
            group: 'degraves1',
            coords: {x: -4016.76, y: 270.66999999999996, z: -618.1199999999999}, mission: '', label: 'Types of coffee'
          },
          {
            id: 7.4, desc: 'Read Street art', icode: 'A1.0', completed: false, active: false, sceneId: 7, iconOrder: 3,
            tipIcon: 'quiz',
            infoSpotId: 'readLane',
            onclick: {
              type: 'show_info',
              popupId: 13,
              audioPrompt: 'assets/audio/0037-acu-audio-37.mp3'
            }, group: 'degraves1',
            coords: {x: -3756.76, y: 550.67, z: 441.8800000000001}, mission: '', label: 'Street art'
          },




          {
            id: 7.5, desc: 'move: to Bourke', icode: 'A1.0', completed: false, active: true, sceneId: 7, iconOrder: 2,
            mission: "<h2>Let’s head over to Bourke Street Mall. </h2><p>Hear about the sights and Melbourne’s great shopping.</p>",
            missionTimer: 500,
            missionIcon: 'map',
            tipIcon: 'goto', group: 'degraves1',
            targetLoc: 8,
            panoName: 'Bourke',
            label: 'Visit Bourke Street Mall',
            coords: {x: 1440, y: -80, z: 1100},
            infoSpotId: 'BourkeLink',
            completeOnMove: true,
            audioPrompt: 'assets/audio/0038-acu-audio-38.mp3'


          },
          {
            id: 7.6, desc: 'move: to Flinders', icode: 'A1.0', completed: false, active: true, sceneId: 7, iconOrder: 2,
            mission: "<h2>Lets get shopping!</h2><p>Bourke Street Mall isn't far away.</p>",
            missionTimer: 500, tipIcon: 'goto', group: 'degraves1',
            targetLoc: 6,
            panoName: 'Flinders',
            label: 'Visit Flinders Street',
            coords: {x: -1620, y: 140, z: -1080},
            infoSpotId: 'FlindersLink',
            completeOnMove: true

          },

          //============================================Bourke Street

          { id: 8.0,  desc:'Hero Text', sceneId: 8, completed: false, active: true, exeOnInit: true, onclick: { type: 'heroText', text: 'Bourke Street Mall'} },
          {
            id: 8.1, desc: 'Bourke Street opener', icode: 'A1.0', completed: false, active: false, sceneId: 8, iconOrder: 1, tipIcon: 'video',
            exeOnInit: true,
            onclick: {
              type: 'play_video', url:'./assets/video/bourke.mp4'
            },
            coords: {x: -3516.76, y: -389.3299999999999, z: -1338.12},
            infoSpotId: 'bourkeOpener',
            label: 'Introduction'
          },
          {
            id: 8.2, desc: 'Read Bourke Street Mall', icode: 'A1.0', completed: false, active: false, sceneId: 8, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readBourke',
            mission:'<h2>Bourke Street Mall</h2><p>The Bourke Street Mall is one of the main streets in Melbourne’s Central Business District. Explore the mall then head off to the Royal Arcade.</p>',
            missionIcon: 'map',
            onclick: {
              type: 'show_info', popupId: 14,
              audioPrompt: 'assets/audio/0041-acu-audio-41.mp3'
            },
            group: 'bourke1', activateGroup: 'bourke1',
            coords: {x: -776.7600000000002, y: -929.33, z: -2918.12},
            label: 'Bourke Street Mall',
            audioPrompt: 'assets/audio/0040-acu-audio-40.mp3'
          },
          {
            id: 8.21, desc: 'Read Other place to shop', icode: 'A1.0', completed: false, active: false, sceneId: 8, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'Shopping',
            onclick: {
              type: 'show_info',
              popupId: 14.1,
              audioPrompt: 'assets/audio/0043-acu-audio-43.mp3'
            },
            group: 'bourke1', activateGroup: 'bourke1',
            coords: {x: -1916.7600000000002, y: -69.33000000000004, z: 901.8800000000001}, mission: '',
            label: 'Other places to shop'
          },

          {
            id: 8.3, desc: 'move: to Royal ', icode: 'A1.0', completed: false, active: false, sceneId: 8, iconOrder: 2,
            mission: "<h2>Let’s take a look in Royal Arcade. </h2><p>Enjoy the architecture and learn some useful words to use when you go shopping.</p>",
            missionIcon: 'map',
            missionTimer: 500, tipIcon: 'goto', group: 'bourke1',
            targetLoc: 9,
            panoName: 'Royal Arcade',
            label: 'Visit Royal Arcade',
            coords: {x: -1816.7600000000002, y: -9.330000000000041, z: -1398.12},
            infoSpotId: 'RoyalLink',
            completeOnMove: true,
            audioPrompt: 'assets/audio/0044-acu-audio-44.mp3'

          },
          {
            id: 8.4, desc: 'move: to Treasury ', icode: 'A1.0', completed: false, active: false, sceneId: 8, iconOrder: 2,
            mission: "<h2>Head over to the Treasury Building</h2><p>Let's go visit the Treasuray Building.</p>",
            missionTimer: 500, tipIcon: 'goto', group: 'bourke1',
            targetLoc: 10,
            panoName: 'Treasury Building',
            label: 'Visit Treasury Building',
            coords: {x: 1683.2399999999998, y: -49.32999999999993, z: 301.8800000000001},
            infoSpotId: 'TreasuryLink',
            completeOnMove: true

          },

          //Royal Aracde
          { id: 9.0,  desc:'Hero Text', sceneId: 9, completed: false, active: true, exeOnInit: true, onclick: { type: 'heroText', text: 'Royal Arcade'} },


          {
            id: 8.1, desc: 'Royal Arcade opener', icode: 'A1.0', completed: false, active: false, sceneId: 9, iconOrder: 1, tipIcon: 'video',
            exeOnInit: true,
            onclick: {
              type: 'play_video', url:'./assets/video/royal.mp4'
            },
            coords: {x: -3516.76, y: -389.3299999999999, z: -1338.12},
            infoSpotId: 'bourkeOpener',
            label: 'Introduction'
          },


          {
            id: 9.3, desc: 'Read Royal Arcade', icode: 'A1.0', completed: false, active: false, sceneId: 9, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readArcade',
            mission: '<h2>Explore Royal Arcade</h2><p>Royal Arcade is one of the main arcades in Melbourne’s Central Business District. Explore the arcade then head to the Treasury Building.</p>',
            missionIcon: 'read',
            onclick: {
              type: 'show_info',
              popupId: 16,
              audioPrompt: 'assets/audio/0048-acu-audio-48.mp3'
            },
            group: 'royal1', activateGroup: 'royal1',
            coords: {x: -2256.76, y: -969.33, z: -1098.12},
            label: 'Royal Arcade',
            audioPrompt: 'assets/audio/0045-acu-audio-45.mp3'
          },

          {
            id: 9.4, desc: 'Shopping inMelnb', icode: 'A1.0', completed: false, active: false, sceneId: 9, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'shoppinmgarcade',
            onclick: {
              type: 'show_info',
              popupId: 17,
              audioPrompt: 'assets/audio/0050-acu-audio-50.mp3'
            },
            group: 'royal1', activateGroup: 'royal1',
            coords: {x: -5276.76, y: -49.33000000000004, z: 1441.88},
            label: 'Shopping in Melbourne'
          },


          {
            id: 9.42, desc: 'move: to Treasury ', icode: 'A1.0', completed: false, active: false, sceneId: 9, iconOrder: 2,
            mission: "<h2>Let’s head over to the Treasury Building</h2><p>Hear about Melbourne’s history and immigration as well as its famous food culture.</p>",
            missionTimer: 500, tipIcon: 'goto', group: 'royal1',
            targetLoc: 10,
            panoName: 'Treasury Building',
            label: 'Visit Treasury Building',
            coords: {x: 1823.2399999999998, y: -69.32999999999993, z: 301.8800000000001},
            infoSpotId: 'TreasuryLink',
            completeOnMove: true,
            audioPrompt: 'assets/audio/0051-acu-audio-51.mp3'
          },
          {
            id: 9.2, desc: 'move: to Degraves', icode: 'A1.0', completed: false, active: true, sceneId: 9, iconOrder: 2,
            tipIcon: 'goto', group: 'royal1',
            targetLoc: 7,
            panoName: 'Degraves',
            label: 'Visit Centre Place',
            coords: {x: -1540, y: 0, z: -64},
            infoSpotId: 'DegravesLink',
            completeOnMove: true

          },
          {
            id: 9.2, desc: 'move: to Bourke Street', icode: 'A1.0', completed: false, active: true, sceneId: 9, iconOrder: 2,
            tipIcon: 'goto', group: 'royal1',
            targetLoc: 8,
            panoName: 'Bourke',
            label: 'Visit Bourke Street Mall',
            coords: {x: 1640, y: -120, z: 900},
            infoSpotId: 'BourkeLink',
            completeOnMove: true
          },
          // ================================================== Treasury


          { id: 10.0,  desc:'Hero Text', sceneId: 10, completed: false, active: true, exeOnInit: true, onclick: { type: 'heroText', text: 'Treasury Building'} },
          {
            id: 10.1, desc: 'Treasury Street opener', icode: 'A1.0', completed: false, active: false, sceneId: 10, iconOrder: 1, tipIcon: 'video', exeOnInit: true,
            onclick: {type: 'play_video', url:'./assets/video/treasury.mp4'},
            coords: {x: -1056.7600000000002, y: -29.329999999999927, z: 1801.88},
            infoSpotId: 'bourkeOpener', label: 'View Intro video'
          },

          {
            id: 10.2, desc: 'Government', icode: 'A1.0', completed: false, active: false, sceneId: 10, iconOrder: 3,
            tipIcon: 'read',
            infoSpotId: 'govSpot',
            mission: '<h2>Explore the Treasury Building</h2><p>This is Melbourne’s main business district, where you will find the Treasury Building. Explore the area then head off to Carlton Gardens.</p>',
            onclick: {
              type: 'show_info',
              popupId: 18,
              audioPrompt: 'assets/audio/0053-acu-audio-53.mp3'
            },
            group: 'tre1', activateGroup: 'tre1',
            coords: {x: -2076.76, y: 510.66999999999996, z: 1301.88},
            label: 'Government in Australia',
            audioPrompt: 'assets/audio/0052-acu-audio-52.mp3'
          },
          {
            id: 10.3, desc: 'Immigration', icode: 'A1.0', completed: false, active: false, sceneId: 10, iconOrder: 1,
            tipIcon: 'read',
            onclick: {
              type: 'show_info',
              popupId: 19,
              audioPrompt: 'assets/audio/0054-acu-audio-54.mp3'
            },
            group: 'tre1',
            coords: {x: 2943.24, y: 50.67000000000007, z: -1598.12},
            infoSpotId: 'Immighr',
            label: 'Immigration in Melbourne'
          },
          {
            id: 10.31, desc: 'Cultural diversity', icode: 'A1.0', completed: false, active: false, sceneId: 10, iconOrder: 1,
            tipIcon: 'read',
            onclick: {
              type: 'show_info',
              popupId: 20,
              audioPrompt: 'assets/audio/0055-acu-audio-55.mp3'
            },
            group: 'tre1',
            coords: {x: -3976.76, y: -69.32999999999993, z: 581.8800000000001},
            infoSpotId: 'culDiv',
            label: 'Cultural diversity'
          },
          {
            id: 10.312, desc: 'Food culture', icode: 'A1.0', completed: false, active: false, sceneId: 10, iconOrder: 1,
            tipIcon: 'read',
            onclick: {
              type: 'show_info',
              popupId: 21,
              audioPrompt: 'assets/audio/0016-acu-audio-16.mp3'
            },
            group: 'tre1',
            coords: {x: 663.2399999999998, y: -89.32999999999993, z: -3878.12},
            infoSpotId: 'foodCul',
            label: 'Food culture'
          },

          {
            id: 10.32, desc: 'The Windsor Hotel', icode: 'A1.0', completed: false, active: false, sceneId: 10, iconOrder: 1, tipIcon: 'video', exeOnInit: true,
            onclick: {type: 'play_video', url:'./assets/video/hitea.mp4'},
            group: 'tre1',
            coords: {x: -5216.76, y: 770.6700000000001, z: -4038.12},
            infoSpotId: 'winsorHotel', label: 'The Windsor Hotel'
          },
          {
            id: 10.4, desc: 'move: to Exhibition', icode: 'A1.0', completed: false, active: true, sceneId: 10, iconOrder: 2,
            mission: "<h2>Let’s head over to the Carlton Gardens</h2><p>Hear about our parks and love of Australian Football.</p>",
            missionTimer: 500, tipIcon: 'goto', group: 'tre1',
            targetLoc: 11,
            panoName: 'Exhibition',
            label: 'Visit Carlton Gardens',
            coords: {x: -1480, y: -40, z: -1060},
            infoSpotId: 'ExhibitionLink',
            completeOnMove: true,
            //audioPrompt: 'assets/audio/0056-acu-audio-56.mp3'

          },
          {
            id: 10.5, desc: 'move: to Bourke Street', icode: 'A1.0', completed: false, active: true, sceneId: 10, iconOrder: 2,
            tipIcon: 'goto', group: 'tre1',
            targetLoc: 8,
            panoName: 'Bourke',
            label: 'Visit Bourke Street Mall',
            coords: {x: 780, y: -20, z: -1740},
            infoSpotId: 'BourkeLink',
            completeOnMove: true

          },


          //Exhibition Gardens
          { id: 11.0,  desc:'Hero Text',
            sceneId: 11, completed: false, active: true, exeOnInit: true,
            onclick: { type: 'heroText', text: 'CARLTON GARDENS'} },
          {
            id: 11.1, desc: 'Exhibition opener', icode: 'A1.0', completed: false, active: false,
            sceneId: 11, iconOrder: 1, tipIcon: 'video', exeOnInit: true,
            onclick: {type: 'play_video', url:'./assets/video/exhibition.mp4'},
            coords: {x: -1276.7600000000002, y: -1549.33, z: 2541.88},
            infoSpotId: 'bourkeOpener', label: 'Introduction',
          },
          {
            id: 11.2, desc: 'Carlton Gardens', icode: 'A1.0', completed: false, active: false,
            sceneId: 11, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readExe',
            onclick: {
              type: 'show_info',
              popupId: 22,
              audioPrompt: 'assets/audio/rec1/carltongardens.mp3'
            },
            group: 'exe1', activateGroup: 'exe1',
            coords: {x: -2036.7600000000002, y: -489.33000000000004, z: 2101.88},
            mission: '<h2>Explore the gardens</h2><p>Take a look around the gardens, then when you are ready, make your way to the ACU campus by turning right.</p>',
            missionIcon: 'map',
            label: 'Carlton Gardens',
            audioPrompt: 'assets/audio/0057-acu-audio-57.mp3'

          },
          {
            id: 11.21, desc: 'Australian Football', icode: 'A1.0', completed: false, active: false,
            sceneId: 11, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readExe',
            onclick: {
              type: 'show_info',
              popupId: 23,
              audioPrompt: 'assets/audio/rec1/afl.mp3'
            },
            group: 'exe1', activateGroup: 'exe1',
            coords: {x: 2723.24, y: -449.33000000000004, z: 1801.88},
            label: 'Australian Football'
          },
          {
            id: 11.22, desc: 'Pets', icode: 'A1.0', completed: false, active: false,
            sceneId: 11, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readExe',
            onclick: {
              type: 'show_info',
              popupId: 24,
              audioPrompt: 'assets/audio/0062-acu-audio-62.mp3'
            },
            group: 'exe1', activateGroup: 'exe1',
            coords: {x: -4596.76, y: -389.33000000000004, z: -178.1199999999999},
            label: 'Pets'
          },
          {
            id: 11.4, desc: 'move: to ACU', icode: 'A1.0', completed: false, active: false,
            sceneId: 11, iconOrder: 2,
            mission: "<h2>It’s time to go to the ACU Melbourne Campus</h2><p>Hear about our university, studying in Australia and take a tour of the campus.</p>",
            missionTimer: 500, missionIcon: 'map', tipIcon: 'goto', group: 'exe1',
            targetLoc: 1,
            panoName: 'Court',
            label: 'Visit ACU Campus',
            coords: {x: 1260, y: -60, z: 400},
            infoSpotId: 'CourtLink',
            completeOnMove: true,
            audioPrompt: 'assets/audio/0063-acu-audio-63.mp3'

          },
          {
            id: 11.3, desc: 'move: to Treasury', icode: 'A1.0', completed: false, active: false,
            sceneId: 11, iconOrder: 2,
            tipIcon: 'goto', group: 'exe1',
            targetLoc: 10,
            panoName: 'Treasury Building',
            label: 'Visit Treasury Building',
            coords: {x: 520, y: 20, z: -1000},
            infoSpotId: 'TreasuryLink',
            completeOnMove: true

          },




          //ACU COURTYARD
          { id:0,  desc:'Hero Text', sceneId: 1, completed: false, active: true, exeOnInit: true, onclick: { type: 'heroText', text: 'Sister of the Mary Cross Courtyard'} },
          {
            id: 1, desc: 'Courtyard opener', icode: 'A1.0', completed: false, active: false, sceneId: 1, iconOrder: 1, tipIcon: 'video', exeOnInit: true,
            onclick: {type: 'play_video', url:'./assets/video/court-1[compressed].mp4'},
            coords: {x: 3183.24, y: -1189.33, z: 1801.88},
            infoSpotId: 'courtOpener', label: 'Introduction video', devNote:'Only a rough version of the video for now.'
          },
          {
            id: 1.1, desc: 'Read', icode: 'A1.0', completed: false, active: false, sceneId: 1, iconOrder: 3, tipIcon: 'read',
            infoSpotId: 'readBackground',
            onclick: {
              type: 'show_info',
              popupId: 2,
              audioPrompt:  './assets/audio/rec1/welcometoacu.mp3'
            }, group: "court1", activateGroup: 'court1',
            coords: {x: 3363.24, y: -469.33000000000004, z: 121.88000000000011}, missionIcon: 'map',
            mission: "<h2>Explore the courtyard</h2><p>Then when you are ready head on in and we'll visit with Stuart, a teacher at ACU.</p>",
            missionTimer: 100, label: 'About Australian Catholic University',

          },
          {
            id: 2.2, desc: 'Welcome', icode: 'A1.0', completed: false, active: false, sceneId: 1, iconOrder: 2, tipIcon: 'video',
            infoSpotId: 'welcomvid',
            group: "court1",
            onclick: {
              type: 'show_info',
              popupId: 2.1,
              audioPrompt:  './assets/audio/rec1/welcome.mp3'

            },
            coords: {x: 1023.2399999999998, y: -509.33000000000004, z: 3141.88},
            label: "Welcome to Country"
          },
          {
            id: 2.2, desc: 'Study', icode: 'A1.0', completed: false, active: false, sceneId: 1, iconOrder: 2, tipIcon: 'quiz',
            infoSpotId: 'studf',
            group: "court1",
            onclick: {
              type: 'show_info',
              popupId: 2.2,
              audioPrompt:  './assets/audio/rec1/studyinginaustralia.mp3'
            },
            coords: {x: 2023.2399999999998, y: -509.33000000000004, z: 3141.88},
            label: "Studying in Australia"
          },

          {
            id: 1.3, desc: 'move: to Classroom', icode: 'A1.0', completed: false, active: false, sceneId: 1, iconOrder: 2,
            mission: "<h4>It’s time to head inside to the classroom and meet Stuart, one of our teachers</h4><p>Hear about making friends, research skills and then meet some of our students.</p>",
            missionTimer: 500, tipIcon: 'goto', group:"court1",
            targetLoc: 2,
            panoName: 'Classroom',
            label: 'Visit ACU Classroom',
            coords: {x: 1020, y: 0, z: 720},
            infoSpotId: 'ClassroomLink',
            completeOnMove: true

          },
          //====================================================== Classroom

          { id:2.0,  desc:'Hero Text 2', sceneId: 2, completed: false, active: true, exeOnInit: true, onclick: { type: 'heroText', text: 'Meet the teacher'}},

          {
            id: 2.1, desc: 'Classroom opener', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1, tipIcon: 'video', exeOnInit: true, infoSpotId: 'outside1', coords: {x: 2380, y: -1100,z: -20}, label: 'Teacher video',
            onclick: {type: 'play_video', url:'./assets/video/outside-classroom-4[compressed].mp4'}

          },
          {
            id: 2.2, desc: 'Classroom', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 2, tipIcon: 'video', exeOnInit: true, infoSpotId: 'classVideo', coords: {x: 3300, y: -720, z: 1720}, label: 'Classroom video',
            onclick: {type: 'play_video', url:'./assets/video/classroom-1[compressed].mp4'}

          },


          {
            id: 2.3, desc: 'read: info', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1,
            label: 'How to make friends',
            infoSpotId: 'friends',
            tipIcon: 'read',
            onclick: {
              type: 'show_info',
              popupId: 30,
              audioPrompt:  './assets/audio/rec1/makingfriends.mp3'
            },
            activateGroup: 'students1',
            coords: {x: 460, y: -1100, z: 1920},
            mission: '<h2>Explore the classroom</h2><p>Then when you are ready, head to the Library by moving to the door your left.</p>',
            missionTimer: 500,
            audioPrompt:  './assets/audio/rec1/exploreclassroom.mp3'

          },
          {
            id: 2.11, desc: 'watched: something', icode: 'A1.0', completed: false, active: false, sceneId: 2,
            iconOrder: 2,
            tipIcon: 'read',
            group: 'students1',
            infoSpotId: 'research1',
            label: 'Research',
            coords: {x: 2563.24, y: -549.33, z: 2761.88},
            onclick: {
              type: 'show_info',
              popupId: 32,
              audioPrompt:  './assets/audio/rec1/researchskills.mp3'
            }

          },


          {
            id: 2.5, desc: 'Student 1', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1,
            tipIcon: 'listen',
            group: 'students1',
            label: 'Adriana',
            activateGroup: 'students1',
            audioPrompt:  './assets/audio/rec1/listentosomestudents.mp3',
            mission: '<h2>Listen to students</h2><p>Listen to some students introduce themselves. Just click on a student. </p>',
            missionTimer: 500, missionIcon: 'listen',
            infoSpotId: 'student1', onclick: {
              type: 'play_sysaudio',
              url: './assets/audio/aleana.mp4',
              img: './assets/images/acu/aleana.jpg',
              title: 'Adriana ',
              desc: "Adriana, a student at <b>ACU</b> from Peru and studying General English and English for Academic Purposes."
            },
            coords: {x: 763.2399999999998, y: -349.33000000000004, z: 4661.88}
          },
          {
            id: 2.6, desc: 'Andrea', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1,
            tipIcon: 'listen',
            group: 'students1', label: 'Andrea',
            infoSpotId: 'student2', onclick: {
              type: 'play_sysaudio',
              url: './assets/audio/andra.mp4',
              img: './assets/images/acu/alena.jpg',
              title: 'Andrea',
              desc: "Meet Andrea, a student from Peru studying General English at ACU."
            },
            coords: {x: 3.2399999999997817, y: -509.33000000000004, z: 2761.88}
          },
          {
            id: 2.7, desc: 'Student 3', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1,
            tipIcon: 'listen',
            group: 'students1', label: 'Maki',
            infoSpotId: 'student3', onclick: {type: 'play_sysaudio',
              url: './assets/audio/miki.mp4',
              img: './assets/images/acu/miki.jpg',
              title: 'Maki',
              desc: "Maki is from Japan and studying English for Academic Purposes as part of the Study Abroad Program. "},
            coords: {x: -1736.7600000000002, y: -369.3299999999999, z: 3441.88}
          },
          {
            id: 2.8, desc: 'Aki', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1,
            tipIcon: 'listen',
            group: 'students1', label: 'Aki',
            infoSpotId: 'student4', onclick: {
              type: 'play_sysaudio',
              url: './assets/audio/aki.mp4',
              img: './assets/images/acu/aki.jpg',
              title: 'Aki',
              desc: "Aki is from Japan and studying English for Academic Purposes and Masters in Public Health. "
            },
              coords: {x: -2456.76, y: -869.3299999999999, z: 2881.88}
          },
          {
            id: 2.9, desc: 'Ditia', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1,
            tipIcon: 'listen',
            group: 'students1', label: 'Ditia',
            infoSpotId: 'student5', onclick: {
              type: 'play_sysaudio',
              url: './assets/audio/ditia.mp4',
              img: './assets/images/acu/ditia.jpg',
              title: 'Ditia ',
              desc: "Meet Ditia, he is from Indonesia and studying English for Academic Purposes and a Masters of Education."
            },
            coords: {x: -656.7600000000002, y: -389.3299999999999, z: 4081.88}
          },
          {
            id: 2.101, desc: 'Sumin', icode: 'A1.0', completed: false, active: false, sceneId: 2, iconOrder: 1,
            tipIcon: 'listen',
            group: 'students1',
            label: 'Sumin',
            infoSpotId: 'Sumin',
            onclick: {
              type: 'play_sysaudio',
              url: './assets/audio/suimin.mp4',
              img: './assets/images/acu/suimin.jpg',
              title: 'Sumin ',
              desc: "Sumin is from South Korea and studying General English."
            },
            coords: {x: 1723.2399999999998, y: -289.3299999999999, z: 3541.88}
          },
          {
            id: 2.12, desc: 'move: to Library', icode: 'A1.0', completed: false, active: true, sceneId: 2, iconOrder: 3,
            mission: '<h2>Let’s go to the library</h2><p>You’ll learn some helpful phrases and hear from some of our students.</p>',
            missionTimer: 500, tipIcon: 'goto',
            targetLoc: 3,
            panoName: 'Library',
            label: 'Visit ACU Library',
            coords: {x: -1000, y: -100, z: -460},
            infoSpotId: 'LibraryLink',
            completeOnMove: true,

          },


          // ===================================== LIBRARY
          { id: 3,  desc:'Hero Text 3',
            sceneId: 3, completed: false, active: true, exeOnInit: true,
            onclick: { type: 'heroText', text: 'ACU Library'}
          },
          {
            id: 3.1,
            desc: 'Library opener',
            icode: 'A1.0',
            completed: false,
            active: true,
            sceneId: 3,
            iconOrder: 1,
            tipIcon: 'goto',
            exeOnInit: true,
            infoSpotId: 'libraryVideo',
            onclick: {type: 'play_video', url: './assets/video/library-3[compressed].mp4'},
            coords: {x: 1003.2399999999998, y: -589.33, z: -1778.12},
            mission: ''
          },

          {
            id: 3.3, desc: 'Useful phrases', icode: 'A1.0', completed: false, active: false, sceneId: 3, iconOrder: 1,
            tipIcon: 'quiz', label: 'Useful phrases',
            group: 'libraryClicks', activateGroup: 'libraryClicks',
            infoSpotId: 'Quiz1',
            mission: '<h2>Explore the library</h2> <p>Take your time to explore – you never know what you might find!</p><p>Then make your way to the Cathedral Hall by turning right.</p>',
            missionIcon: 'map',
            onclick: {
              type: 'play_quiz',
              quizId: 3.1,
              audioPrompt: './assets/audio/rec1/usefulphrases.mp3'
            },
            coords: {x: 903.2399999999998, y: -589.33, z: 4081.88},
            audioPrompt: './assets/audio/rec1/explorethelibrary.mp3'
          },


          {
            id: 3.4, desc: 'Listen: Library Students', icode: 'A1.0', completed: false, active: false, sceneId: 3, iconOrder: 1,
            tipIcon: 'quiz', label: 'Groupwork', group: 'libraryClicks',
            infoSpotId: 'Quiz2', onclick: {
              type: 'play_quiz',
              quizId: 3.4,
              audioPrompt: './assets/audio/groupwork.mp3'
            },
            coords: {x: 2283.24, y: -589.33, z: 2961.88}
          },
          {
            id: 3.5, desc: 'Read: Extract', icode: 'A1.0', completed: false, active: false, sceneId: 3, iconOrder: 1,
            tipIcon: 'quiz', label: 'Read an extract ', group: 'libraryClicks',
            infoSpotId: 'Quiz3', onclick: {
              type: 'play_quiz',
              quizId: 3.5,
              audioPrompt: './assets/audio/readextract.mp3'
            },
            coords: {x: 2523.24, y: 290.66999999999996, z: 801.8800000000001}
          },
          {
            id: 3.6, desc: 'Listen: Fav book', icode: 'A1.0', completed: false, active: false, sceneId: 3, iconOrder: 1,
            tipIcon: 'listen', label: 'Favourite book', group: 'libraryClicks',
            infoSpotId: 'Listen2', onclick: {
              type: 'play_sysaudio',
              url: './assets/audio/0003-acu-audio-3_01.mp3',
              img: './assets/images/acu/stuart.jpg',
              title: 'My favourite book',
              desc: "Listen to Stuart talk about his favourite book and why he enjoys reading.",
              html: '<img class="imgFluid animated flipInY delay-5s" src="./assets/images/acu/movablefeast.jpg" style="width: 50%;margin-left: 20%;">'
            },
            audioPrompt:  './assets/audio/rec1/favouritebook.mp3',

            coords: {x: 503.2399999999998, y: -589.33, z: 4081.88}
          },
          {
            id: 3.8, desc: 'move: to hall', icode: 'A1.0', completed: false, active: false,
            sceneId: 3, iconOrder: 1,
            group: 'libraryClicks',
            tipIcon: 'goto',
            targetLoc: 4,
            panoName: 'Hall',
            label: 'Visit Cathedral Hall',
            coords: {x: -720, y: 0, z: 1220},
            infoSpotId: 'HallLink',
            missionIcon: 'map',
            mission: '<h2>It’s time to visit a special place –<br> the Cathedral Hall</h2><p>Take a look to find out why Melbourne is known for its excellent music scene.</p>',
            audioPrompt:  './assets/audio/rec1/visitaspecialplacecathedralhall.mp3',
          },
          {
            id: 3.7, desc: 'move: to classroom', icode: 'A1.0', completed: false, active: false,
            sceneId: 3, iconOrder: 1,
            group: 'libraryClicks',
            tipIcon: 'goto',
            targetLoc: 2,
            panoName: 'Classroom',
            label: 'Visit Classroom',
            coords: {x: 1000, y: -40, z: -1220},
            infoSpotId: 'ClassroomLink'
          },


          // ===================================== Cathedral Hall

          { id:4.0,  desc:'Hero Text 3', sceneId: 4, completed: false, active: true, exeOnInit: true, onclick: { type: 'heroText', text: 'Cathedral Hall'}},

          {
            id: 4.1, desc: 'Hall opener', icode: 'A1.0', completed: false, active: false,
            sceneId: 4,
            iconOrder: 1, tipIcon: 'video', exeOnInit: true, group: 'ch1',
            infoSpotId: 'HallVideo', onclick: {type: 'play_video', url: './assets/video/hall-med-2[compressed].mp4'},
            coords: {x: -976.7600000000002, y: -869.33, z: -1938.12}, mission: '', label: 'Introduction'
          },
          {
            id: 4.3, desc: 'Read', icode: 'A1.0', completed: false, active: false,
            sceneId: 4,
            iconOrder: 3, tipIcon: 'read', group: 'ch1', activateGroup: 'ch1',
            infoSpotId: 'readHall', onclick: {
              type: 'show_info',
              popupId: 31,
              audioPrompt:  './assets/audio/rec1/culturalcapital.mp3'
            },
            coords: {x: -496.7600000000002, y: 50.66999999999996, z: -2938.12}, label: 'Cultural capital',
            mission: '<h2>Explore Cathedral Hall</h2><p>Explore the Cathedral Hall then make your way to our final stop – the rooftop garden. You will find it by turning to the right.</p>',
            missionIcon: 'map',
            audioPrompt:  './assets/audio/rec1/cathedralhall.mp3',

          },
          {
            id: 4.31, desc: 'Video', icode: 'A1.0', completed: false, active: false,
            sceneId: 4,
            iconOrder: 3, tipIcon: 'video', group: 'ch1', activateGroup: 'ch1',
            infoSpotId: 'songSpot',
            onclick: {
              type: 'show_info', popupId: 31.1,
              audioPrompt:  './assets/audio/rec1/listentoadriana.mp3'
            },
            coords: {x: -1556.7600000000002, y: 50.66999999999996, z: -2938.12},
            label: 'Talented Students'

          },
          {
            id: 4.3, desc: 'move: to rooftop', icode: 'A1.0', completed: false, active: false,
            sceneId: 4,
            group: 'ch1',
            iconOrder: 1,
            tipIcon: 'goto',
            targetLoc: 5,
            panoName: 'Rooftop',
            label: 'Visit ACU Rooftop Cafe',
            coords: {x: -1280, y: -20, z: -960},
            infoSpotId: 'roofLink',
            mission: '<h2>It’s time for our last stop<br>– the rooftop garden</h2><p>Learn about Australian foods and hear what we’re doing to help the environment.<\p>',
            missionIcon: 'map'
          },
          {
            id: 4.5, desc: 'move: to Library', icode: 'A1.0', completed: false, active: false,
            sceneId: 4, iconOrder: 3,
            group: 'ch1',
            mission: '',
            missionTimer: 500, tipIcon: 'goto',
            targetLoc: 3,
            panoName: 'Library',
            label: 'Visit ACU Library',
            coords: {x: 560, y: 20, z: 1460},
            infoSpotId: 'LibraryLink',
            completeOnMove: true

          },



          //Rooftop

          {
            id: 5.0,  desc:'Hero Text 3',
            sceneId: 5, completed: false, active: true, exeOnInit: true,
            onclick: { type: 'heroText', text: 'ACU Rooftop Garden'}
          },
          {
            id: 5.1, desc: 'Rooftop opener', icode: 'A1.0', completed: false, active: false,
            sceneId: 5,
            iconOrder: 1,
            tipIcon: 'video',
            exeOnInit: true,
            infoSpotId: 'rt1Video',
            onclick: {
              type: 'play_video',
              url: './assets/video/roof-1[compressed].mp4'
            },
            coords: {x: -2916.76, y: -329.33000000000004, z: 1841.88},
            mission: '', label: 'Introduction'
          },
          {
            id: 5.4, desc: 'Read', icode: 'A1.0', completed: false, active: false,
            sceneId: 5,
            iconOrder: 3, tipIcon: 'read',
            activateGroup: 'rf1',
            group: 'rf1',
            infoSpotId: 'readFood',
            onclick: {
              type: 'show_info',
              popupId: 51,
              heading: 'Australian Foods',
              audioPrompt: './assets/audio/rec1/aussiefoods.mp3'
            },
            coords: {x: 3203.24, y: -1069.33, z: -1038.12},
            label: 'Australian Foods',
            mission: '<h2>ACU Rooftop Garden</h2><p>This is the last stop on our virtual tour today. Take a look around and enjoy the view by moving left and right! </p>',
            missionIcon: 'map',
            audioPrompt:  './assets/audio/rec1/thisisourlaststop.mp3'
          },
          {
            id: 5.2, desc: 'Aust Food', icode: 'A1.0', completed: false, active: false,
            sceneId: 5,
            iconOrder: 2,
            tipIcon: 'video',
            group: 'rf1',
            infoSpotId: 'foodVideo1',
            onclick: {
              type: 'play_video',
              url: './assets/video/food-1[compressed].mp4'
            },
            coords: {x: 1743.2399999999998, y: -1049.33, z: -1938.12},
            label: 'Australian food'
          },


          {
            id: 5.6, desc: 'Environment', icode: 'A1.0', completed: false, active: false,
            sceneId: 5,
            iconOrder: 3, tipIcon: 'read',group: 'rf1',
            infoSpotId: 'readbins', onclick: {
              type: 'show_info',
              popupId: 52,
              heading: 'Helping the environment ',
              audioPrompt: './assets/audio/rec1/environment.mp3'
            },
            coords: {x: -4056.76, y: -29.33000000000004, z: -1218.12}, mission: '', label: 'Helping the environment '
          },

          {
            id: 5.7, desc: 'Mannix', icode: 'A1.0', completed: false, active: false,
            sceneId: 5,
            iconOrder: 3, tipIcon: 'read',
            group: 'rf1',
            infoSpotId: 'ammnix', onclick: {
              type: 'show_info',
              popupId: 53,
              audioPrompt: './assets/audio/rec1/danielmannix.mp3'
            },
            coords: {x: -2756.76, y: -9.330000000000041, z: -2998.12},
            label: 'Green star rating'
          },
          {
            id: 5.8, desc: 'FINAL', icode: 'A1.0', completed: false, active: false,
            sceneId: 5,
            exeOnInit: true,
            iconOrder: 3,
            tipIcon: 'exit',
            group: 'rf1',
            onclick: {
              type: 'show_info',
              popupId: 54,
              audioPrompt: './assets/audio/rec1/thanks.mp3'
            },
            coords: {x: -2936.76, y: -349.3299999999999, z: 781.8800000000001},
            label: 'More information',
            infoSpotId: 'finale'
          },

          {
            id: 5.9, desc: 'move: to hall', icode: 'A1.0', completed: false, active: false,
            sceneId: 5,
            iconOrder: 3,
            group: 'rf1',
            tipIcon: 'goto',
            targetLoc: 4,
            panoName: 'Hall',
            label: 'Visit Cathedral Hall',
            coords: {x: -1540, y: -60, z: -860},
            infoSpotId: 'HallLink1'
          },




        ]
      }



    ];




    this.panels = {
      scene1: {
        panel1: {show: true, desc: 'Welcome'},
        panel2: {show: true, desc: 'Mouse move done'},
        panel3: {show: true, desc: 'Onto next topic'}

      },
      scene2: {},
      scene3: {
        //Storeroom
        panel1: {show: false, desc: 'Backstock Pick'},
        panel2: {show: false, desc: 'Tour Flow'},

      },
      scene4: {
        panel1: {show: false, desc: 'Pick Cage'},


      }
    };

  }


  test() {
    console.log('TEST');
  }

}


